import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Mail',
      label: 'Email',
      value: 'Fawasbello9@gmail.com',
      href: 'mailto:Fawasbello9@gmail.com',
      description: 'Best for project inquiries'
    },
    {
      icon: 'Phone',
      label: 'Phone',
      value: '+234 (091) 3760-9550',
      href: 'tel:+2349137609550',
      description: 'Available Mon-Fri, 9AM-6PM EST'
    },
    {
      icon: 'MapPin',
      label: 'Location',
      value: '',
      href: null,
      description: 'Open to remote opportunities'
    }
  ];

  const socialLinks = [
    {
      icon: 'Github',
      label: 'GitHub',
      href: 'https://github.com/ggrey-coder',
      username: '@ggrey-coder'
    },
    {
      icon: 'Linkedin',
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/in/fawaz-bello-3a8a113bb',
      username: ''
    },
    {
      icon: 'Twitter',
      label: 'Twitter',
      href: 'Loading',
      username: ''
    }
  ];

  return (
    <div className="bg-surface rounded-xl p-6 shadow-subtle h-fit">
      <h3 className="text-xl font-semibold text-foreground mb-6">
        Get in Touch
      </h3>
      {/* Contact Methods */}
      <div className="space-y-4 mb-8">
        {contactMethods?.map((method, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={method?.icon} size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">
                {method?.label}
              </p>
              {method?.href ? (
                <a
                  href={method?.href}
                  className="text-primary hover:text-primary/80 transition-colors duration-200 break-all"
                >
                  {method?.value}
                </a>
              ) : (
                <p className="text-muted-foreground break-all">
                  {method?.value}
                </p>
              )}
              <p className="text-xs text-muted-foreground mt-1">
                {method?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Social Links */}
      <div className="border-t border-border pt-6">
        <h4 className="text-sm font-medium text-foreground mb-4">
          Connect on Social
        </h4>
        <div className="space-y-3">
          {socialLinks?.map((social, index) => (
            <a
              key={index}
              href={social?.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200 group"
            >
              <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center group-hover:bg-primary/10 transition-colors duration-200">
                <Icon 
                  name={social?.icon} 
                  size={16} 
                  className="text-muted-foreground group-hover:text-primary transition-colors duration-200" 
                />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">
                  {social?.label}
                </p>
                <p className="text-xs text-muted-foreground">
                  {social?.username}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
      {/* Response Time */}
      <div className="mt-6 p-4 bg-accent/10 rounded-lg">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Clock" size={16} className="text-accent" />
          <p className="text-sm font-medium text-foreground">
            Response Time
          </p>
        </div>
        <p className="text-sm text-muted-foreground">
          I typically respond within 24 hours during business days.
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
